import { render } from "./ReporteGeneral.vue?vue&type=template&id=5711057c"
import script from "./ReporteGeneral.vue?vue&type=script&lang=js"
export * from "./ReporteGeneral.vue?vue&type=script&lang=js"

import "./ReporteGeneral.vue?vue&type=style&index=0&id=5711057c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__